let aboutData = {
  heading: 'RC Medical',
  paragraph: 'RC-Medical brand was created in cooperation and business expansion of Rue Cambon and Med Point companies, in response for market needs dictated by COVID-19 pandemic.  Above all we offer single-use products, that meet the necessary norms, are fully certified and guarantee the best quality. RC-Medical is the sole distributor of MGI Medical products.',
};

export { aboutData };